import React, { useEffect, useState, useRef } from "react";
import { DraftRoomContainer, DraftRoomColumn } from "./DraftRoomComponent.styles";
import DraftRoomPartPlayers from "./DraftRoomPartPlayers";
import DraftRoomFavouritePicks from "../DraftRoomFavouritePicks/DraftRoomFavouritePicks";
import DraftRoomStimulyatorPart from "../DraftRoomStimulyatorPart/DraftRoomStimulyatorPart";
import { toast } from "react-toastify";
import {useNavigate} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    getTeamsDraftRoom,
    fetchFirstPlayersForTeams,
    preloadPlayersForTeams,
    draftUserTeamPlayer
} from "../../app/features/stimulyatorDraftRoom/stimulyatorDraftRoomAction";
import {
    selectStimulyatorDrafRoom, setChosenTeam,setRound,
    setPausedForUserPick,
} from "../../app/features/stimulyatorDraftRoom/stimulyatorDraftRoomSlice";



function DraftRoomComponent(props) {
    const [pickedPlayers, setPickedPlayers] = useState([]);
    const dispatch = useDispatch();
    const { teamDraftPlayerChoose, isPausedForUserPick, playerCache,chosenPlayerIds} = useSelector(selectStimulyatorDrafRoom);
    const [currentTeamIndex, setCurrentTeamIndex] = useState(0);
    const tableRef = useRef(null);
    const [viewMode, setViewMode] = useState('players');
    const navigate = useNavigate();
    const round=props?.draftRoomEvent?.rounds;
    const chosenTeam=props?.draftRoomEvent?.team;


    useEffect(() => {
        if (round !== undefined) dispatch(setRound(round));
        if (chosenTeam !== undefined) dispatch(setChosenTeam(chosenTeam));
    }, [round, chosenTeam]);


    useEffect(() => {
        dispatch(getTeamsDraftRoom());
    }, [dispatch]);

    useEffect(() => {
        setPickedPlayers((prev) =>
            prev.filter((player) => !chosenPlayerIds.includes(player.id))
        );
    }, [chosenPlayerIds]);


    useEffect(() => {
        if (teamDraftPlayerChoose.length > 0 && Object.keys(playerCache).length === 0) {
            dispatch(preloadPlayersForTeams());
        }
    }, [teamDraftPlayerChoose, playerCache, dispatch]);


    useEffect(() => {
        if (!teamDraftPlayerChoose.length || !round) return;
        const isDraftFinished = teamDraftPlayerChoose.every(
            team => team.choosePlayers.length === Number(round)
        );
        if (isDraftFinished) {
            setViewMode('finish');
            dispatch(setPausedForUserPick(true));
        }
    }, [teamDraftPlayerChoose, round, dispatch]);


    useEffect(() => {
        const fetchNextTeam = async () => {
            console.log("fetchNextTeam...")

            if (teamDraftPlayerChoose.length === 0) return;
            let currentTeam = teamDraftPlayerChoose[currentTeamIndex];
            if (!currentTeam) return;
            if (currentTeam.name === chosenTeam) {
                dispatch(setPausedForUserPick(true));
                setViewMode('players');
                return;
            }
            setViewMode('auto');
            await dispatch(fetchFirstPlayersForTeams(currentTeam));
            if (currentTeamIndex < teamDraftPlayerChoose.length - 1) {
                setCurrentTeamIndex(prev => prev + 1);
            } else {
                setCurrentTeamIndex(0);
            }
        };
        if (!isPausedForUserPick && teamDraftPlayerChoose.length > 0) {
            const delay = setTimeout(fetchNextTeam, 800);
            return () => clearTimeout(delay);
        }
    }, [teamDraftPlayerChoose, currentTeamIndex, isPausedForUserPick, dispatch, chosenTeam]);

    useEffect(() => {
        if (tableRef.current) {
            const roundRow = tableRef.current.querySelector(`[data-round="${round}"]`);
            if (roundRow) {
                roundRow.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    }, [round]);


    const addPickedPlayers = (data) => {
        if (chosenPlayerIds.includes(data.id)) {
            toast.error("This player is already drafted!");
            return;
        }
        setPickedPlayers((prev) => {
            const exists = prev.some((p) => p.id === data.id);
            if (exists) {
                toast.error(`Player is already in your list!`);
                return prev;
            }
            return [...prev, data];
        });
    };

    const addPlayerToChosenTeam = (data) => {
        const currentTeam = teamDraftPlayerChoose[currentTeamIndex];//new
        if (currentTeam?.name !== chosenTeam) {
            toast.error(`WAIT! It's not your turn now!`);
            return;
        }
        if (chosenPlayerIds.includes(data.id)) {
            toast.error("This player is already drafted!");
            return;
        }
        dispatch(draftUserTeamPlayer(data))
            .unwrap()
            .then(() => {
                toast.success(`${data.player} drafted to your team!`);
                setViewMode('players');
                setCurrentTeamIndex((prev) =>
                    prev < teamDraftPlayerChoose.length - 1 ? prev + 1 : 0
                );
            })
            .catch((err) => {
                toast.error(err || "Error drafting player");
            });
    }

    return (
        <DraftRoomContainer>
            <DraftRoomColumn>
                <div className="title">Player List</div>
                <DraftRoomPartPlayers
                    showPlayers={viewMode === 'players'}
                    onSetPickedPlayers={addPickedPlayers}
                    onAddPlayer={addPlayerToChosenTeam}
                />
            </DraftRoomColumn>
            <DraftRoomColumn>
                <div className="title">Picks</div>
                <DraftRoomFavouritePicks
                    onAddPlayer={addPlayerToChosenTeam}
                    pickedPlayers={pickedPlayers}
                    setPickedPlayers={setPickedPlayers}
                />
            </DraftRoomColumn>
            <DraftRoomColumn ref={tableRef}>
                <div className="title">Overall Picks (Round {round})</div>
                <DraftRoomStimulyatorPart round={round} chosenTeam={chosenTeam}/>
                {viewMode === 'finish' && (
                    <button
                        className="finish-btn"
                        onClick={() => navigate('/draft-result-room')}
                    >
                        Generate the graphic
                    </button>
                )}
            </DraftRoomColumn>
        </DraftRoomContainer>
    );
}

export default DraftRoomComponent;